export default __webpack_public_path__ + "static/media/carrinho.395a737b.svg";